const actions = {
  REGISTER_REQUEST: 'REGISTER_REQUEST',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_ERROR: 'REGISTER_ERROR',

  register: (user) => ({
    type: actions.REGISTER_REQUEST,
    user: user,
  })
};

export default actions;
